import _ from 'lodash'

// https://stackoverflow.com/a/37066038
export const isArrayEqual = function <T>(x: T[], y: T[]) {
  return _(x).xorWith(y, _.isEqual).isEmpty()
}
